import { Product } from "../types/store";

export type CatalogMutation =
  | { type: "upsert"; product: Product }
  | { type: "delete"; productId: number }
  | { type: "refresh" };

const EVENT_NAME = "catalog:mutation";
const STORAGE_KEY = "eldoo-catalog-refresh";
const channel = typeof BroadcastChannel !== "undefined"
  ? new BroadcastChannel("eldoo-catalog")
  : null;

export const publishCatalogMutation = (mutation: CatalogMutation) => {
  window.dispatchEvent(new CustomEvent<CatalogMutation>(EVENT_NAME, { detail: mutation }));
  channel?.postMessage(mutation);

  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ nonce: `${Date.now()}-${Math.random()}`, type: "refresh" }),
    );
  } catch {
    // Cross-tab sync still works through BroadcastChannel where supported.
  }
};

export const subscribeToCatalogMutations = (listener: (mutation: CatalogMutation) => void) => {
  const handleLocalMutation = (event: Event) => {
    listener((event as CustomEvent<CatalogMutation>).detail);
  };
  const handleBroadcastMutation = (event: MessageEvent<CatalogMutation>) => listener(event.data);
  const handleStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY && event.newValue) {
      listener({ type: "refresh" });
    }
  };

  window.addEventListener(EVENT_NAME, handleLocalMutation);
  channel?.addEventListener("message", handleBroadcastMutation);
  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener(EVENT_NAME, handleLocalMutation);
    channel?.removeEventListener("message", handleBroadcastMutation);
    window.removeEventListener("storage", handleStorage);
  };
};
